import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  Input,
  MenuItem,
  FormHelperText
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

const InputSelect = props => {
  const {
    values,
    touched,
    errors,
    handleBlur,
    setFieldValue,
    name,
    label,
    className,
    options,
    margin = "dense",
    variant = "standard",
    labelProps = {},
    inputProps = {},
    onSelectedOptionChange = (o) => {},
    displayNameSelector,
    uniqueKeySelector,
  } = props;
  const { t } = useTranslation();

  const handleChange = (event) => {
    var newValue = event.target.value;

    setFieldValue(name, newValue);
    onSelectedOptionChange(newValue);
  }

  return (
    <FormControl
      fullWidth
      margin={margin}
      className={className}
      variant={variant}
    >
      <InputLabel htmlFor={name} {...labelProps}>
        {t(label)}
      </InputLabel>
      <Select
        error={errors[name] && touched[name]}
        input={<Input id={name} name={name} {...inputProps} />}
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        renderValue={o => displayNameSelector(o)}
      >
        {options.map(o => (
          <MenuItem key={uniqueKeySelector(o)} value={o}>
            {displayNameSelector(o)}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText className="MuiFormHelperText-root Mui-error">
        {errors[name] && touched[name] ? t(errors[name].value) : " "}
      </FormHelperText>
    </FormControl>
  );
};

export default InputSelect;
